<ng-template #defTemplate let-tag><span class="default-template">{{ tag }}</span></ng-template>

@for (tag of selectedTags; track tag) {
  <div class="tag">
    <ng-container *ngTemplateOutlet="tagTemplate ? tagTemplate : defTemplate; context: {$implicit: tag}"></ng-container>
    @if (!disabled) {
      <i class="material-icons remove" (click)="removeTag(tag)">remove</i>
    }
  </div>
}

@if (!disabled && !hideControls && (limit === null || selectedTags?.length < limit) && !isAdding && !(addingModeWhenEmpty && selectedTags?.length === 0)) {
  <i
  class="material-icons add" (click)="add()">add</i>
}
@if (isAdding || (addingModeWhenEmpty && (!selectedTags || selectedTags?.length === 0))) {
  <div class="add-controls">
    @if (inputType === 'dropdown') {
      <app-dropdown (cancelled)="isAdding = false" [(ngModel)]="tagToAdd"
        [disabled]="disabled || (limit !== null && selectedTags.length >= limit)"
        [list]="UnaddedTags" [placeholder]="placeholder ?? defaultDropdownPlaceholder"
      [template]="tagTemplate ? tagTemplate : defTemplate"></app-dropdown>
    }
    @if (inputType === 'text') {
      <input type="text" [(ngModel)]="tagToAdd" (keydown.enter)="addSelectedTag()"
        [placeholder]="placeholder ?? defaultPlaceholder"/>
    }
    @if (inputType === 'typeahead') {
      <app-typeahead [placeholder]="placeholder ?? defaultPlaceholder" [displayTemplate]="typeaheadWrapper"
        [options]="tagList" [ngModel]="tagToAdd" [selectOnly]="typeaheadSelectOnly" [displayWith]="typeaheadDisplayWith"
      (ngModelChange)="typeaheadTagSelected($event)"></app-typeahead>
    }
    <i class="material-icons" (click)="addSelectedTag()">check</i>
    <i class="material-icons" (click)="cancelAdd()">close</i>
  </div>
}

<ng-template #typeaheadWrapper let-option="option" let-idx="idx">
  <ng-container *ngTemplateOutlet="tagTemplate ? tagTemplate : defTemplate; context: {option, idx}"></ng-container>
</ng-template>
